function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgViewDetail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "View Details Icon",
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16",
    d: "M11.138 7.8 6.313 2.978 1.489 7.8 0 6.313 6.313 0l6.313 6.313z",
    transform: "rotate(90 5.107 19.294)",
    style: {
      fill: "#2e2e2e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 9396",
    style: {
      stroke: "#eaeaea",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    style: {
      fill: "none"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewDetail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view-detail.05516b22.svg";
export { ForwardRef as ReactComponent };